import { useQuery } from '@apollo/react-hooks';
import { IGarantie, IGarantieCouverture } from '../context/model';
import { COLLECTIVE_OFFERS_QUERY } from '../services/CmsService';
import * as garantiesConfig from "./garanties_retraite.json";

type GarantyType = {
  loading: boolean;
  garanties: IGarantie[];
}


export default function useFetchRetiredGaranties(): GarantyType {
  /*
  const { loading, data } = useQuery(
    COLLECTIVE_OFFERS_QUERY,
    { variables: { parentPath: "/sites/mgp/affiliation-collectif/contenu/offres" } }
  );

  let garanties: IGarantie[] = [];
  const hasDoneLoading = !loading && data?.jcr?.nodeByPath?.children?.nodes?.length >0;

  if(hasDoneLoading) {
      data.jcr.nodeByPath.children.nodes.forEach((node: any) => {
          garanties.push({
            code: node.offerCode.value,  
            titre: node.titre.value,
            subTitre: node.subTitre.value,
            garantieRecommandee: node.garantieRecommandee.value === 'true',
            totaleMensualite: Number(node.totaleMensualite.value),
            partSalarieMensualite: Number(node.partSalarieMensualite.value),
            partEmployeurMensualite: Number(node.partEmployeurMensualite.value),
            santeclairInclus: node.santeclairInclus.value  === 'true',
            garantieBase: node.garantieBase.value === 'true',
            servicesInclusTexte: node.servicesInclusTexte.value,
            couvertures: node.descendants.nodes.map((c: any) => {
                return {
                    couvertureTitre: c.couvertureTitre.value,
                    couvertureChiffre: Number(c.couvertureChiffre.value),
                    couvertureUnit: c.couvertureUnit.value,
                    description: c.description.value,
                    exempleTitre: c.exempleTitre.value,
                    exempleDescription: c.exempleDescription.value,
                    exempleCoutTotal: Number(c.exempleCoutTotal.value),
                    exemplePartSecu: Number(c.exemplePartSecu.value),
                    exemplePartMgp: Number(c.exemplePartMgp.value),
                    exemplePartAdherent: Number(c.exemplePartAdherent.value),
                    exemplePrecision: c.exemplePrecision? c.exemplePrecision.value : '',
                } as IGarantieCouverture;
            })
          })
      });
    }
    */

    // Temporairie for recette
  const garanties = JSON.parse(JSON.stringify(garantiesConfig)).data as Array<IGarantie>;
   
  const loading = false;

  return { loading, garanties};
}
